// **** import modules ****
import app, { csl } from "@@assets/scripts/common";
import Swiper, { EffectFade, Navigation, Pagination} from 'swiper'
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
Swiper.use([EffectFade, Navigation, Pagination])
import "./_products";


// **** process ****
app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
	const swiper = new Swiper(".swiper-container", {
		effect: "fade",
		fadeEffect: {
			crossFade: true
		},
		loop: true,
		speed: 2000,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true
		}
	});
	csl.log("item", swiper);
});

app.exec();
